module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.change
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c8d8062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileInput.vue
// module id = 465
// module chunks = 1